import axios from '@core/utils/axios';

export default {
    getItemsPaginationLimit: (limit: number = 10) => {
        let limitSaved = localStorage.getItem('itemPaginationLimit');
        return limitSaved ? +limitSaved : limit;
    },
    changeOwner: async (company: string, person: string) => (await axios.put(`/company/${company}/change/owner`, {person})).data,
}